import { Component } from '@angular/core';
import { ActionButtonsComponent } from '../../../components/action-buttons/action-buttons.component';
import { CompanyFitComponent as SharedCompanyFitComponent } from '../../../components/company-fit/company-fit.component';
import { SpacesService } from '../../../services/spaces.service';
import { ModalService } from '../../../services/modal.service';

@Component({
  selector: 'app-company-fit-page',
  standalone: true,
  imports: [SharedCompanyFitComponent, ActionButtonsComponent],
  templateUrl: './company-fit.component.html',
  styleUrl: './company-fit.component.scss'
})
export class CompanyFitComponent {
  constructor(
    private readonly spacesService: SpacesService,
    private readonly modalService: ModalService
  ) {}

  resetAll(): void {
    this.spacesService.clearActiveSpace();
  }

  openSaveToSpaces(): void {
    this.modalService.openCreateSpaceModal(this.spacesService.getActiveSpace());
  }
}
